const headers = {
  name: "Inventory batch",
  navigate: {
    path: [
      {
        name: "Batch",
        path: "/app/inventory",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
